import React from "react";
import * as Icons from "lucide-react";
import { SERVICES } from "@/data/site";

const scrollTo = (id) => {
  const el = document.querySelector(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const Services = () => {
  return (
    <section id="services" data-testid="services-section" className="bg-slate-50 border-y border-slate-200">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-14 py-24 md:py-32">
        <div className="grid lg:grid-cols-12 gap-8 items-end mb-16">
          <div className="lg:col-span-8">
            <div className="overline text-blue-600 mb-6">What we do</div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-light tracking-tighter text-slate-950 text-balance max-w-3xl">
              A complete suite of glass, aluminum and interior services — under one roof.
            </h2>
          </div>
          <div className="lg:col-span-4 lg:text-right">
            <p className="text-slate-600 max-w-md lg:ml-auto">
              Whether you need a single frameless shower installed or a full commercial fit-out, our
              craftsmen deliver with precision, speed, and premium finish.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-slate-200" data-testid="services-grid">
          {SERVICES.map((s, i) => {
            const Icon = Icons[s.icon] || Icons.Square;
            return (
              <div
                key={s.name}
                data-testid={`service-card-${i}`}
                className="group relative bg-white p-8 hover:bg-slate-900 transition-colors duration-500 cursor-default"
              >
                <div className="flex items-start justify-between mb-8">
                  <div className="h-11 w-11 border border-slate-300 group-hover:border-white/40 flex items-center justify-center transition-colors">
                    <Icon className="h-5 w-5 text-slate-800 group-hover:text-white transition-colors" strokeWidth={1.5} />
                  </div>
                  <span className="text-[10px] uppercase tracking-[0.2em] text-slate-400 group-hover:text-white/50 transition-colors">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                </div>
                <h3 className="font-display text-lg font-medium text-slate-950 group-hover:text-white transition-colors leading-tight">
                  {s.name}
                </h3>
                <p className="mt-3 text-sm text-slate-600 group-hover:text-white/70 transition-colors leading-relaxed">
                  {s.desc}
                </p>
              </div>
            );
          })}
        </div>

        <div className="mt-14 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-slate-600">Can&apos;t find the service you need? We take on custom briefs.</p>
          <button
            data-testid="services-cta"
            onClick={() => scrollTo("#contact")}
            className="bg-slate-900 hover:bg-slate-800 text-white px-8 py-4 text-xs uppercase tracking-[0.22em] font-semibold transition-colors"
          >
            Request a Custom Quote
          </button>
        </div>
      </div>
    </section>
  );
};
